import React from "react";
import Taeguk from "./Taegeuk.svg";

import "./Spinner.css";

const spinner = (props) => (
  <div className="spinner-container">
    {/* <div className="yy-spinner"></div> */}
    <img src={Taeguk} className="taeguk-spinner" alt="Taeguk Loading" />
    <div className="spinner-text-loading">
      <h2 className="glow">{props.loadingText}</h2>
    </div>
  </div>
);

export default spinner;
